import React, {Component} from 'react';
import {Button, Form, Grid, Header, Input, Label, Message, Radio, Segment} from "semantic-ui-react";
import {COMPANY_API_URL, PROPERTY_API_URL} from "../../constants/api_routes";
import ListingContainer from "../../containers/listing_container";
import {getAgentsOfCompany, getListingData} from "../../data/user_api";

const furnishMap = {"furnished": '0', "semifurnished": '2', "unfurnished": '1'};

class UpdateProperty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            garage: undefined,
            alarm: undefined,
            numberOfBedroom: undefined,
            furnishingType: undefined,
            errorMessage: undefined,
            bedRoomExist: true,
            furnishingAvailable: true,
            currentUser: undefined,
            agentListOptions: [],
            companyId: undefined,
            assignedAgent: undefined,
            companyListOptions: [],
            companyValid: true,
            agentValid: true,
        }
    }

    componentWillMount() {
        const selectedObject = this.props.selectedObject[0];
        this.setState({
            garage: selectedObject.garage ? "yes" : "no",
            alarm: selectedObject.alarm ? "yes" : "no",
            numberOfBedroom: selectedObject['no_of_bedrooms'] === "studio" ? "0" : selectedObject['no_of_bedrooms'],
            furnishingType: furnishMap[selectedObject['furnishing_type']],
            currentUser: JSON.parse(localStorage.getItem('user')),
            companyId: selectedObject['company_id']
        });
        this.getAgentList(selectedObject['company_id']).then(() => {
            this.setState({assignedAgent: selectedObject['agent_profile_id']})
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        if (this.state.numberOfBedroom === undefined) {
            this.setState({bedRoomExist: false});
            return;
        }
        if (this.state.furnishingType === undefined) {
            this.setState({furnishingAvailable: false});
            return;
        }
        if (this.state.assignedAgent === undefined) {
            this.setState({agentValid: false});
            return;
        }
        formData.append("no_of_bedrooms", this.state.numberOfBedroom);
        formData.append("furnishing_type", this.state.furnishingType);
        formData.append("agent_profile_id",this.state.assignedAgent);
        this.props.updateDetails(PROPERTY_API_URL, formData, this.props.selectedObject[0].id, this.updateSuccessCallback, this.props.noLoad);
    };

    updateSuccessCallback = (response) => {
        if (response.success) {
            this.props.back("Successfully Updated");
        }
        else {
            this.setState({errorMessage: "Something went wrong! please try again later"})
        }
    };

    getAgentList = async (companyId) => {
        const agentList = await getAgentsOfCompany(COMPANY_API_URL, companyId);
        let agentOptions = [];
        for (let i = 0; i < agentList.length; i++) {
            let obj = {
                key: agentList[i].id,
                text: agentList[i].name,
                value: agentList[i].id
            };
            agentOptions.push(obj);
        }
        this.setState({agentListOptions: agentOptions});
    };

    getCompanyList = async () => {
        const companyList = await getListingData(COMPANY_API_URL);
        let companyOptions = [];
        for (let i = 0; i < companyList.length; i++) {
            let obj = {
                key: companyList[i].id,
                text: companyList[i].name,
                value: companyList[i].id
            };
            companyOptions.push(obj);
        }
        this.setState({companyListOptions: companyOptions});
    };


    render() {
        const selectedProperty = this.props.selectedObject[0];
        const currentUserDetails = this.state.currentUser;
        const furnishOptions = [
            {key: '1', text: 'Furnished', value: '0'},
            {key: '2', text: 'Part-Furnished', value: '2'},
            {key: '3', text: 'Un-Furnished', value: '1'},
        ];

        const bedRoomOptions = [
            {key: '0', text: 'Studio', value: '0'},
            {key: '1', text: '1 Bedroom', value: '1'},
            {key: '2', text: '2 Bedroom', value: '2'},
            {key: '3', text: '3 Bedroom', value: '3'},
            {key: '4', text: '4 Bedroom', value: '4'},
            {key: '5', text: '5 Bedroom', value: '5'},
            {key: '6', text: '6 Bedroom', value: '6'},
            {key: '7', text: '7 Bedroom', value: '7'},
            {key: '8', text: '8 or Above Bedroom', value: '8'},
        ];

        const {garage, alarm} = this.state;
        return (<div>
            <Header content="Edit property" size="large" textAlign="center"/>
            <Form onSubmit={this.handleSubmit}>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment>
                                <input type='hidden' name='property_address_id'
                                       defaultValue={selectedProperty.address.id}/>
                                <Label color='blue' ribbon>
                                    Property Owner
                                </Label>
                                <p></p>
                                {currentUserDetails['role'] === 'admin' &&
                                    <Form.Dropdown
                                        label='Agent Name'
                                        required
                                        search
                                        noResultsMessage="Agent not found"
                                        error={!this.state.agentValid}
                                        selection
                                        wrapSelection={false}
                                        options={this.state.agentListOptions}
                                        placeholder='Agent Name'
                                        defaultValue={selectedProperty['agent_profile_id']}
                                        onFocus={()=>this.setState({agentValid:true})}
                                        onChange={(e, option) => {
                                            this.setState({assignedAgent: option.value})
                                        }}
                                    />
                                }
                                <Form.Input label="Owner Name" icon='user' iconPosition='left'
                                            type='text' name="owner_name"
                                            defaultValue={selectedProperty['owner_name']}
                                            />

                                <Form.Input label="Email Address" icon='at' iconPosition='left'
                                            name="owner_email" defaultValue={selectedProperty['owner_email']}
                                            />

                                <Form.Input label="Mobile Number" icon='mobile' iconPosition='left'
                                            type='text' name="owner_mobile_number"
                                            defaultValue={selectedProperty['owner_mobile_number']}
                                            />

                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Property Address Details
                                </Label>
                                <p></p>
                                <Form.Input label="Address Line 1"
                                            placeholder='Street'
                                            readOnly={currentUserDetails['role'] !== 'admin'}
                                            name="line1" defaultValue={selectedProperty.address.line1}
                                            required/>
                                <Form.Input label="Address Line 2"
                                            placeholder='Landmark'
                                            readOnly={currentUserDetails['role'] !== 'admin'}
                                            name="line2" defaultValue={selectedProperty.address.line2}
                                />
                                <Form.Group widths={2}>
                                    <Form.Input label="Locality"
                                                placeholder='Region'
                                                readOnly={currentUserDetails['role'] !== 'admin'}
                                                type='text' name="locality"
                                                defaultValue={selectedProperty.address.locality}
                                    />
                                    <Form.Input label="City"
                                                type='text' name="city"
                                                readOnly={currentUserDetails['role'] !== 'admin'}
                                                defaultValue={selectedProperty.address.city}
                                    />
                                </Form.Group>
                                <Form.Group widths={2} className="field">
                                    <Form.Input label="Country" placeholder='Country'
                                                type='text' name="country"
                                                readOnly={currentUserDetails['role'] !== 'admin'}
                                                defaultValue={selectedProperty.address.country}
                                    />
                                    <Form.Input label="Post Code" placeholder='C2PN57'
                                                type='text' name="postcode" required
                                                readOnly={currentUserDetails['role'] !== 'admin'}
                                                defaultValue={selectedProperty.address.postcode}
                                    />
                                </Form.Group>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Meter and gauge Details
                                </Label>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Gas Meter Number</label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <Input placeholder="18537850" type='text' name="gas_meter_sno"
                                                       defaultValue={selectedProperty['gas_meter_sno']}
                                                />
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row style={{paddingTop:'0'}}>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Gas meter location</label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <Input placeholder="front-lobby" type="text" name="gas_meter_location"
                                                       defaultValue={selectedProperty['gas_meter_location']}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row style={{paddingTop:'0'}}>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Electric Meter Number </label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <Input placeholder="18537850" type="text" name="electric_meter_sno"
                                                       defaultValue={selectedProperty['electric_meter_sno']}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row style={{paddingTop:'0'}}>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Electric Meter Location</label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <Input placeholder="front-lobby" type="text"
                                                       name="electric_meter_location"
                                                       defaultValue={selectedProperty['electric_meter_location']}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row style={{paddingTop:'0'}}>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Water Meter Number </label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <Input placeholder="18537850" type="text" name="water_meter_sno"
                                                       defaultValue={selectedProperty['water_meter_sno']}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row style={{paddingTop:'0'}}>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Water Meter Location </label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <Input placeholder="front-lobby" type="text"
                                                       name="water_meter_location"
                                                       defaultValue={selectedProperty['water_meter_location']}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row style={{paddingTop:'0'}}>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Property Notes</label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.TextArea placeholder="Meter code: 1234" type="text"
                                                       name="property_notes"
                                                       defaultValue={selectedProperty['property_notes']}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Property Specifications
                                </Label>
                                <p></p>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>No. Of Bedrooms</label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Dropdown
                                                required
                                                selection
                                                error={!this.state.bedRoomExist}
                                                defaultValue={this.state.numberOfBedroom.toString()}
                                                wrapSelection={false}
                                                options={bedRoomOptions}
                                                placeholder='No. of bedrooms'
                                                onFocus={()=>this.setState({bedRoomExist:true})}
                                                onChange={(e, option) => {
                                                    this.setState({numberOfBedroom: option.value})
                                                }}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Field >
                                                <label>No. of Bathrooms </label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <Input placeholder='1 0r 2'
                                                       name="no_of_bathrooms" defaultValue={selectedProperty['no_of_bathrooms']}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>
                                                    Furnishing Type
                                                </label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Dropdown
                                                required
                                                selection
                                                error={!this.state.furnishingAvailable}
                                                defaultValue={furnishMap[selectedProperty['furnishing_type']]}
                                                wrapSelection={false}
                                                options={furnishOptions}
                                                placeholder='Furnishing Type'
                                                onFocus={()=>this.setState({furnishingAvailable:true})}
                                                onChange={(e, option) => {
                                                    this.setState({furnishingType: option.value})
                                                }}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Garage</label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Group inline>
                                                <Form.Field
                                                    control={Radio}
                                                    label='Yes'
                                                    value='yes'
                                                    name="garage"
                                                    checked={garage === 'yes'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({garage: value})
                                                    }}
                                                />
                                                <Form.Field
                                                    control={Radio}
                                                    label='No'
                                                    value='no'
                                                    name="garage"
                                                    checked={garage === 'no'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({garage: value})
                                                    }}
                                                />
                                            </Form.Group>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Field>
                                                <label>Alarm</label>
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Group inline>
                                                <Form.Field
                                                    control={Radio}
                                                    label='Yes'
                                                    value='yes'
                                                    name="alarm"
                                                    checked={alarm === 'yes'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({alarm: value})
                                                    }}
                                                />
                                                <Form.Field
                                                    control={Radio}
                                                    label='No'
                                                    value='no'
                                                    name="alarm"
                                                    checked={alarm === 'no'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({alarm: value})
                                                    }}
                                                />
                                            </Form.Group>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {this.state.errorMessage && <Message style={{width: '100%'}} color="red"
                                                     onDismiss={() => this.setState({errorMessage: undefined})}>{this.state.errorMessage}</Message>}
                <p></p>
                <div className="submit-buttons" style={{padding: '1%'}}>
                    <Button type='submit' primary>Update Property</Button>
                </div>
            </Form>
        </div>);
    }

}

export default ListingContainer(UpdateProperty);


// WEBPACK FOOTER //
// ./src/views/properties/update_property_details.js